import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';
import { STORE } from '../lib/i18n';

export default function Nav() {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 6);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  const onHome = loc.pathname === '/';

  return (
    <nav className={`nav ${scrolled || !onHome ? 'scrolled' : ''}`} data-testid="main-nav">
      <div className="wrap nav-inner">
        <Link to="/" className="logo" data-testid="logo-link">
          <span className="logo-mark"><span>N</span></span>
          <span>Nathanael <span style={{ color: 'var(--blue)' }}>Appliances Corp</span></span>
        </Link>

        <div className="nav-links">
          <NavLink to="/shop" className="link" data-testid="nav-shop">{t('nav.shop')}</NavLink>
          {onHome ? (
            <a href="#shipping" className="link" data-testid="nav-shipping">{t('nav.shipping')}</a>
          ) : (
            <Link to="/#shipping" className="link" data-testid="nav-shipping">{t('nav.shipping')}</Link>
          )}
          {onHome ? (
            <a href="#why" className="link" data-testid="nav-about">{t('nav.about')}</a>
          ) : (
            <Link to="/#why" className="link" data-testid="nav-about">{t('nav.about')}</Link>
          )}
          {onHome ? (
            <a href="#contact" className="link" data-testid="nav-contact">{t('nav.contact')}</a>
          ) : (
            <Link to="/#contact" className="link" data-testid="nav-contact">{t('nav.contact')}</Link>
          )}

          <div className="lang-toggle" role="group" aria-label="Language">
            <button className={lang === 'en' ? 'active' : ''} onClick={() => setLang('en')} data-testid="lang-en-btn">EN</button>
            <button className={lang === 'es' ? 'active' : ''} onClick={() => setLang('es')} data-testid="lang-es-btn">ES</button>
          </div>

          <a href={`tel:${STORE.phoneRaw}`} className="nav-call" data-testid="nav-call-button">
            <i className="fa-solid fa-phone"></i>
            <span>{STORE.phone}</span>
          </a>
        </div>

        <div className="nav-mobile-actions">
          <button className="nav-burger" onClick={() => setOpen(o => !o)} aria-label="Menu" data-testid="mobile-menu-button">
            <i className={open ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-menu open">
          <Link to="/shop">{t('nav.shop')}</Link>
          <Link to="/#shipping">{t('nav.shipping')}</Link>
          <Link to="/#why">{t('nav.about')}</Link>
          <Link to="/#contact">{t('nav.contact')}</Link>
          <a href={`tel:${STORE.phoneRaw}`} style={{ color: 'var(--blue)' }}>
            <i className="fa-solid fa-phone"></i> {STORE.phone}
          </a>
          <div className="lang-toggle" style={{ marginTop: 12 }}>
            <button className={lang === 'en' ? 'active' : ''} onClick={() => setLang('en')}>EN</button>
            <button className={lang === 'es' ? 'active' : ''} onClick={() => setLang('es')}>ES</button>
          </div>
        </div>
      )}
    </nav>
  );
}
